import React from 'react';
import Slider from "react-slick";
import './Home.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Home() {
  const heroSlides = [
    {
      title: "Welcome to Sharanga Aqua Farms",
      subtitle: "Your trusted partner in sustainable aquaculture solutions, dedicated to quality, innovation, and environmental responsibility. At Sharanga Aqua Farms, we nurture aquatic life with precision and deliver seafood with unmatched freshness to global standards.",
      image: "/images/hero_banner1.jpg"
    },
    {
      title: "Nurtured with Precision",
      subtitle: "Sharanga ensures every fish is raised with care and expertise.",
      image: "/images/hero-banner2.png"
    },
    {
      title: "Delivered with Freshness",
      subtitle: "From hatchery to harvest, we guarantee quality at every stage.",
      image: "/images/hero-banner3.png"
    }
  ];

  const operations = [
    { title: 'Hatchery', image: '/images/operation1.jpg' },
    { title: 'Farms', image: '/images/operation2.jpg' },
    { title: 'Feed', image: '/images/operation3.jpg' },
    { title: 'Processing Plants', image: '/images/operation4.jpg' },
    { title: 'Exports', image: '/images/operation5.jpg' },
    { title: 'Distribution', image: '/images/operation6.png' }
  ];

  const products = [
    { title: 'Vannamei Prawn', image: '/images/product3.jpg' },
    { title: 'Pomfret Fish', image: '/images/pamplate_fish.jpeg' },
    { title: 'Scampi Prawn', image: '/images/product2.jpg' },
    { title: 'Rohu Fish', image: '/images/rohu_fish.jpg' },
    { title: 'Processed Seafood', image: '/images/product4.jpg' },
    { title: 'Catla Fish', image: '/images/Catla_fish.jpg' },
    { title: 'Grasscrap Fish', image: '/images/Grasscrap Fish.jpg' },
    { title: 'Tiger Prawn', image: '/images/scampi_prawn.jpg' },
    { title: 'Barramundi Fish', image: '/images/pangasius_fish.jpg' },
    { title: 'Tilapia Fish', image: '/images/tilapia_fish.png' }
  ];

  const marketLocations = [
    {
      city: "Kothota",
      image: "/images/kothata.jpg",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3832.376894862042!2d81.51302407494067!3d16.426038484297894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37f401d5d01591%3A0x6d0a5aee7f62e95!2sKothota%2C%20Andhra%20Pradesh%20534281!5e0!3m2!1sen!2sin!4v1718112345678"
    },
    {
      city: "Bhimavaram",
      image: "/images/bhimavaram.jpg",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3832.376894862042!2d81.51302407494067!3d16.426038484297894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37f401d5d01591%3A0x6d0a5aee7f62e95!2sKothota%2C%20Andhra%20Pradesh%20534281!5e0!3m2!1sen!2sin!4v1718112345678"
    },
    {
      city: "Vijayawada",
      image: "/images/vijayawada.jpeg",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.9371691671466!2d80.62845687498175!3d16.504398684232378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fbdf2b72dd19%3A0x7eac61a6a87d0d0a!2sLabbipet%2C%20Vijayawada%2C%20Andhra%20Pradesh%20520010!5e0!3m2!1sen!2sin!4v1718112345678"
    },
    {
      city: "Hyderabad",
      image: "/images/cable_bridge.jpg",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.3360069510385!2d78.38624507496463!3d17.44946060433144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e9f775799b%3A0xb64a7611b4963c3b!2sMadhapur%2C%20Hyderabad%2C%20Telangana%20500081!5e0!3m2!1sen!2sin!4v1718112345678"
    },
     {
      city: "Bhubaneswar",
      image: "/images/orissa.jpeg",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3819.123456789!2d85.123456789!3d20.123456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a123456789abcdef%3A0x123456789abcdef!2sBhubaneswar%2C%20Odisha!5e0!3m2!1sen!2sin!4v1718112345678"
    },
    {
      city: "Kolkata",
      image: "/images/kolkata.jpg",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.170194960832!2d88.42685507499926!3d22.60626033662692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277572f524e6d%3A0x90a0601e53086e37!2sSector%20V%2C%20Salt%20Lake%20City%2C%20Kolkata%2C%20West%20Bengal%20700091!5e0!3m2!1sen!2sin!4v1718112345678"
    }
  ];

  const heroSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-carousel">
        <Slider {...heroSettings}>
          {heroSlides.map((slide, index) => (
            <div key={index}>
              <div className="hero-slide" style={{ backgroundImage: `url(${slide.image})` }}>
                <div className="hero-caption">
                  <h1>{slide.title}</h1>
                  <p>{slide.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>

      {/* About Us */}
      <section className="about-section">
        <h2>About Us</h2>
        <p>
         Sharanga Aqua Farms is a next-generation aquaculture company committed to sustainable and ethical seafood production. Located in the fertile regions of Kothota, Andhra Pradesh, we are driven by a passion for aquatic excellence and a mission to supply premium, traceable, and environmentally responsible seafood to both domestic and international markets.
        </p>
      </section>

      {/* Operations Section */}
      <section className="operations-grid-section">
        <h2 className="section-title">OPERATIONS</h2>
        <p className="operations-desc">
          The company’s ethos strongly relies on an integrated work cycle with operations in hatchery, farms, feed, processing plants, exports & distribution.
        </p>
        <div className="operations-grid">
          {operations.map((op, index) => (
            <div className="operation-tile" key={index}>
              <img src={op.image} alt={op.title} />
              <div className="operation-overlay">
                <span>{op.title}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Products Section */}
      <section className="services-section">
        <h2 className="section-title">PRODUCTS</h2>
        <Slider
          dots={false}
          infinite={true}
          speed={1000}
          slidesToShow={3}
          slidesToScroll={1}
          autoplay={true}
          autoplaySpeed={2500}
          arrows={true}
          responsive={[
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } }
          ]}
        >
          {products.map((item, index) => (
            <div className="industry-card no-button" key={index}>
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
            </div>
          ))}
        </Slider>
      </section>

      {/* Market Section */}
      <section className="market-section">
        <h2 className="section-title">MARKET PRESENCE</h2>
        <p className="market-desc">
          Sharanga Aqua Farms proudly serves across India with major presence in key cities.
        </p>
        <div className="market-grid">
          {marketLocations.map((loc, idx) => (
            <div className="market-card" key={idx}>
              <img src={loc.image} alt={loc.city} className="market-city-img" />
              <h4>{loc.city}</h4>
              <div className="market-map-embed">
                <iframe
                  src={loc.mapSrc}
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={loc.city}
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
